import NoUserRoot from './NoUserRoot';

export default NoUserRoot;